import styles from './page.module.css'

const Page = ({ children, transparent = false }) => {
    return (<main className={transparent ? styles.transparent : ''}> {children}</main>)
};

export default Page;
